import {
  IJourneyLeg,
  MILLISECONDS_PER_MINUTE,
  TRANSFER_LEG_TYPE,
} from '@web/dtos';

export function isTransferLeg(leg: IJourneyLeg): boolean {
  return leg.type === TRANSFER_LEG_TYPE;
}

export function getTransferLabel(
  leg: IJourneyLeg,
  nextLeg?: IJourneyLeg,
  nextDepartureTime?: string | null,
  previousArrivalTime?: string | null
): string {
  const durationMinutes = nextLeg
    ? getDurationMinutes(
        leg.origin.date,
        previousArrivalTime || leg.origin.time,
        nextLeg.origin.date,
        nextDepartureTime || nextLeg.origin.time
      )
    : getLegDurationMinutes(leg);

  return durationMinutes && durationMinutes > 0
    ? `Umstieg ca. ${durationMinutes} min`
    : 'Umstieg';
}

export function getShortOperatorName(operatorName: string): string {
  return operatorName.trim().split(/\s+/)[0] ?? '';
}

export function getTransportName(
  leg: IJourneyLeg,
  fallback: string = getShortOperatorName(leg.operator.name)
): string {
  return leg.name.trim() || fallback;
}

function getLegDurationMinutes(leg: IJourneyLeg): number | undefined {
  return getDurationMinutes(
    leg.origin.date,
    leg.origin.time,
    leg.destination.date,
    leg.destination.time
  );
}

function getDurationMinutes(
  startDate: string,
  startTime: string,
  endDate: string,
  endTime: string
): number | undefined {
  const departure = Date.parse(`${startDate}T${startTime}`);
  const arrival = Date.parse(`${endDate}T${endTime}`);

  if (!Number.isFinite(departure) || !Number.isFinite(arrival)) {
    return undefined;
  }

  return Math.max(
    0,
    Math.round((arrival - departure) / MILLISECONDS_PER_MINUTE)
  );
}
